import { FlagType } from '~/flags/flags';
import { getFlag } from '~/flags/useFlag';
import { Permission } from '~/types/Permission';

import { and } from './utils/and';

const hasPlaybooks = () => getFlag(FlagType.Playbooks);

export const canUsePlaybooks: Permission = and([hasPlaybooks]);
